import React from "react";
import { motion } from "framer-motion";
import { InnerPageNav, Footer } from "./";
import Faq from "react-faq-component";
const FrequentAsk = () => {
  const data = {
    title: "",
    rows: [
      {
        title: "What is Cloudax?",
        content: `Cloudax is a collaborative enterprise and Web3 ecosystem
        built to power the faith-based community and wholesome
        content.`,
      },
      {
        title: "What does Cloudax do?",
        content:
          `Cloudax will provide a platform for impact and profit-driven
          faith-based wholesome content businesses to earn money.
          Within the Cloudax ecosystem, users will have access to a
          unified suite of tools that will allow them to get value
          from their consumption of curated content from their
          preferred content providers while also earning from doing
          so.`,
      },
      {
        title: "How is Cloudax different from other Blockchain projects?",
        content:
         `Cloudax is a real-world application web3 project that would
         power the faith-based community and enabling users and
         content creators earn while enjoying contents.`,
      },
      {
        title: "What are the available products in Cloudax Ecosystem?",
        content: ` Our other products are: Crypto Wallet, NFT Marketplace,
        Launchpad, Decentralized Exchange (DEX), E-commerce.`,
      },
      {
        title: "What problem is Cloudax solving?",
        content: `The problems Cloudax is solving include: High Transaction
        Fees with International Cross-Border Transactions, Slow
        Cross-Border Transfers, Security risks, High inflation,
        amongst others.`,
      },
      {
        title: "What is $CLDX token total supply?",
        content: `The total supply of Cloudax tokens is 10,000,000,000 (Ten
            Billion) CLDX tokens`,
      },
      {
        title: "What is $CLDX circulating supply?",
        content: `Cloudax initial circulating supply is 559,000,000 (559
            million) CLDX tokens`,
      },
      {
        title: "What is the ticker symbol for Cloudax?",
        content: `Cloudax ticker is $CLDX.`,
      },
      {
        title: "What type of token is $CLDX?",
        content: `Cloudax Token ($CLDX) is a BEP-20 native utility token that
        would govern the Cloudax Network.`,
      },
      {
        title: "Where is the CLDX token built on?",
        content: `Cloudax token ($CLDX) is built on the Binance Smart Chain
        but would be deployed across other networks`,
      },
      {
        title: "What solutions/services will Cloudax provide for users?",
        content: `Providing blockchain-powered financial infrastructure to
        facilitate cheap and fast cross-border payments, Providing
        safe, low risk and high-yield crypto savings assets that let
        people beat inflation, Providing a simple way for most
        people to conduct business and get paid easily and
        instantly. Amongst others…`,
      },
      {
        title: "Can I stake $CLDX token on Cloudax?",
        content: `Yes! You will definitely earn $CLDX tokens for providing
        liquidity to the Cloudax ecosystem.`,
      },
      {
        title: "Stay updated with the latest & news!",
        content: `Get all the latest updates, special offers, premium content and
        more when you subscribe. Don’t worry, we’re not interested in
        sending any junk.`,
      },
    ],
  };

  return (
    <>
      <InnerPageNav />

      <section className="section wf-section mt-20">
        <motion.h1
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }}
          className="heading-large globalheader1 aligncenter"
        >
          <span className="color-text-gradient">
            Frequently Asked Questions
          </span>
        </motion.h1>
      </section>

      <section className="section wf-section tok">
        <div className="section-display-wrapper">
          <div className="section wf-section">
            <div className="content-wrapper faqwrap">
              <Faq data={data} />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default FrequentAsk;
